import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import { api } from '@/api'
import ChampionshipMemberCard from '@/components/Cards/ChampionshipMemberCard'
import Section from '@/components/Section'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import React from 'react'
import style from '../styles/members.module.scss'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import Button from '@/components/Button'
import { IChampionshipMember } from '@/interfaces/Championship'
import { useCurrentUser } from '@/hooks'
import Search from './Search'
import NoSearchResults from '@/components/NoSearchResults'

interface IProps {
  championshipId: number | string
}

const ChampionshipMembers = ({
  championshipId
}: IProps): React.ReactElement => {
  const { currentUser } = useCurrentUser()

  return (
    <Section>
      <FetcherList
        initFilter={{ page_size: 30, id: championshipId }}
        isScrollTop={false}
        isHistoryPush={false}
        api={api.getChampionshipMembers}
      >
        {({
          results,
          status,
          showMore,
          loadData,
          filterParams,
          isNext
        }: IFetcherListResults<IChampionshipMember[]>) => {
          return (
            <>
              <Search
                handleFilter={loadData}
                initFilters={filterParams}
                status={status}
              />

              {status === dataStates.loaded && results.length === 0
                ? (
                  <NoSearchResults />
                  )
                : null}

              {results.length > 0
                ? (
                  <ul className={style.members_list}>
                    {results.map(el => {
                      return (
                        <li className={style.members_list__item} key={el.id}>
                          <ChampionshipMemberCard
                            place={el?.place}
                            name={el.user.name}
                            photo={el.user.personal_photo}
                            score={el.property_score_value}
                            isCurrentUser={el.user.id === currentUser?.id}
                            city={el.user.personal_city}
                            state={el.user.personal_state}
                          />
                        </li>
                      )
                    })}
                  </ul>
                  )
                : null}

              {status === dataStates.loading ? <BlockSpinner /> : null}

              {isNext
                ? (
                  <Button
                    onClick={showMore}
                    disabled={status === dataStates.loading}
                    size='large'
                    wide
                    outline
                  >
                    Показать еще
                  </Button>
                  )
                : (
                    undefined
                  )}
            </>
          )
        }}
      </FetcherList>
    </Section>
  )
}

export default ChampionshipMembers
